.label {
  align-self: center;
  margin-left: 0.25rem;
  color: var(
    --h5w-selector-label--color,
    var(--h5w-toolbar-label--color, royalblue)
  );
  white-space: nowrap;
}

.groups {
  margin: -0.5rem 0 0;
  padding-left: 0;
  list-style-type: none;
}

.groups > li {
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
}

.groupLabel {
  margin-bottom: 0.25rem;
  padding-left: 0.75rem;
  color: var(--h5w-selector-groupLabel--color, gray);
  text-transform: uppercase;
  font-size: 0.75em;
  font-weight: 600;
}
